import * as React from "react";
import { MATURITY_THRESHOLD_PERCENT_TEXT } from "src/components/Reporting/utils/maturity";

const LessThanOrEqualToThreshold = (): JSX.Element => {
  return <>&lt;= {MATURITY_THRESHOLD_PERCENT_TEXT}</>;
};

export default LessThanOrEqualToThreshold;
